import { Injectable } from '@angular/core';
 
@Injectable({ providedIn: 'root' })
export class RecaptchaLoaderService {
  private promise?: Promise<void>;
  
  load(): Promise<void> {
    if (this.promise) return this.promise;
 
    this.promise = new Promise((resolve) => {
      if (window.grecaptcha?.render) { 
        resolve(); 
        
        return; 
      }
 
      const script = document.createElement('script');
      
      script.src = 'https://www.google.com/recaptcha/api.js?render=explicit';
      script.async = true;
      script.defer = true;
 
      script.onload = () => window.grecaptcha.ready(() => resolve());
      document.head.appendChild(script);
    });
 
    return this.promise;
  }
}
